// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1_5Bj","subheader":"ReorderModal_subheader__hZnMD","listWrap":"ReorderModal_listWrap__3kqXP"};